import "./App.css";
import React, { useEffect, useState } from "react";
import md5 from "md5";
import CreateAccForm from "./pages/CreateAccForm";
import ForgotPassword from "./pages/ForgotPassword";
import Signin from "./pages/Signin";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import LandingPage from "./pages/LandingPage";
import Tradetab from "./pages/Tradetab";
import MobileCurrency from "./pages/MobileCurrency";
import MobileOrderHistory from "./pages/MobileOrderHistory";
import Myportfolio from "./pages/Myportfolio";
import AllNotifications from "./pages/AllNotifications";
import CryptoWallet from "./pages/CryptoWallet";
import CryptoDeposit from "./pages/CryptoDeposit";
import CryptoWithdraw from "./pages/CryptoWithdraw";
import INRWallet from "./pages/INRWallet";
import INRDeposit from "./pages/INRDeposit";
import INRWithdraw from "./pages/INRWithdraw";
import Transactions from "./pages/Transactions";
import AccountSettings from "./pages/AccountSettings";
import Onboarding from "./pages/Onboarding";
import Settings from "./pages/Settings";
import Invite from "./pages/Invite";
import Bank from "./pages/Bank";
import NotFoundPage from "./pages/NotFoundPage";
import Layout from "./Layout";
import PreLayout from "./PreLayout";
import ContactUs from "./pages/ContactUs";
import Careers from "./pages/Careers";
import AboutUs from "./pages/AboutUs";
import BugBounty from "./pages/BugBounty";
import FeesPage from "./pages/FeesPage";
import TandC from "./pages/TandC";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AmlKyc from "./pages/AmlKyc";
import Lend from "./pages/Lend";
import { format } from "date-fns";
import { isMobile, isIOS } from "react-device-detect";

import ScrollToTop from "./ScrollToTop";

import {
  Route,
  Switch,
  useHistory,
  withRouter,
  useLocation,
  Redirect,
  matchPath,
} from "react-router-dom";
import Button from "@material-ui/core/Button";
import CoinContextProvider from "./contexts/CoinContext";
import Wallet from "./pages/Wallet";
import { useDispatch, useSelector } from "react-redux";
import UPIDepositRequest from "./pages/UPIDepositRequest";
import { Toaster } from "react-hot-toast";
import { useTheme } from "@material-ui/core";
import useResizer from "./services/useResizer";
import { Helmet } from "react-helmet";
import usePageTracking from "./services/usePageTracking";
import InstantDeposit from "./pages/InstantDeposit";
import DirectDeposit from "./pages/DirectDeposit";
import PrivateRoute from "./components/PrivateRoute";
import fetcher from "./api/swr_fetcher";
import {
  fetchFreshchatData,
  initFreshchatSession,
  updateFreshchatRestoreId,
} from "./services/freshchat";
import { customAlphabet } from "nanoid";
import { copyTextAndSendToApp } from "./services/appMethods";
import {
  SET_IGNORE_MOBILE_APP,
  SET_IS_USING_MOBILE_APP,
  SET_USER_PROFILE,
} from "./redux/types";
import {
  makeStyles,
  withStyles,
  MuiThemeProvider,
  createMuiTheme,
} from "@material-ui/core/styles";
import { FaTimes } from "react-icons/fa";
import Drawer from "@material-ui/core/Drawer";
import UPIDeposit from "./pages/INRDeposit/UPIDeposit";

const nanoid = customAlphabet("1234567890abcdef", 16);

// return (
//   <Route
//     {...rest}
//     render={(props) =>
//       authed === true ? (
//         <Component {...props} />
//       ) : (

//       )
//     }
//   />
// );

function Routes(props) {
  const location = useLocation();
  const dispatch = useDispatch();
  const darkMode = useSelector((state) => state.trading.DARK_MODE);
  const loginId = useSelector((state) => state.trading.LOGIN_ID);
  const isUsingMobileApp = useSelector(
    (state) => state.trading.IS_USING_MOBILE_APP
  );

  let history = useHistory();

  const isMobile = useResizer();
  usePageTracking();

  useEffect(() => {
    let value = Boolean(window.localStorage.getItem("is_using_app"));
    dispatch({
      type: SET_IS_USING_MOBILE_APP,
      payload: value,
    });
  }, []);

  useEffect(() => {
    document.addEventListener("copy", async (event) => {
      const selection = document.getSelection().toString();
      copyTextAndSendToApp(selection);
    });
    if (loginId) {
      fetcher("/v1/account").then((data) => {
        dispatch({ type: SET_USER_PROFILE, payload: data });
        if (data.email) {
          doFreshchatConfiguration(data.email);
        }
      });
    }
  }, [loginId]);

  useEffect(() => {
    let pathnames = [
      "/",
      // "/contactus",
      "/careers",
      // "/aboutus",
      // "/bugbounty",
      "/tandc",
      "/privacy",
      "/aml",
    ];

    if (
      isUsingMobileApp &&
      pathnames.find((ele) => ele.includes(location.pathname))
    ) {
      history.push("/trade/BTC");
    }
  }, [location.pathname, isUsingMobileApp]);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, [darkMode]);

  async function doFreshchatConfiguration(email) {
    let uuid = null;

    fetchFreshchatData()
      .then((data) => {
        initFreshchatSession(data.customId, data.restoreId, freshchatOnInit);
      })
      .catch((err) => {
        initFreshchatSession(email, null, freshchatOnInit);

        return;
      });
  }

  function fetchAccountDetailsAndUpdateFreshchat() {
    fetcher("/v1/account").then((data) => {
      if (data) {
        window.fcWidget.user.setProperties({
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          phone: data.phonenumber,
          phoneCountry: data.countryCode,
          dateJoined: format(new Date(data.dateJoined), "MMM d, yyyy hh:mm a"),
        });
      }
    });
  }

  async function freshchatOnInit() {
    window.fcWidget.on("widget:loaded", () => {
      window.fcWidget.user.get(function (resp) {
        var status = resp && resp.status,
          data = resp && resp.data;
        if (status == 200 && data) {
          updateFreshchatRestoreId(data.identifier, data.restoreId);
          fetchAccountDetailsAndUpdateFreshchat();
        }
      });

      window.fcWidget.on("unreadCount:notify", (resp) => {
        dispatch({
          type: "SET_FRESHCHAT_UNREAD_COUNT",
          payload: resp.count,
        });
      });
      window.fcWidget.on("user:created", (resp) => {
        // let slicedLoginId = loginId.slice(0, 10);
        // let uuid = md5(slicedLoginId);
        var status = resp && resp.status,
          data = resp && resp.data;
        if (status === 200) {
          if (data) {
            updateFreshchatRestoreId(data.externalId, data.restoreId);
            fetchAccountDetailsAndUpdateFreshchat();
          }
        }

        let pathnames = [
          "/",
          "/createacc",
          "/forgotpassword",
          "/login",
          "/contactus",
          "/careers",
          "/aboutus",
          // "/bugbounty",
          "/feespage",
          "/tandc",
          "/privacy",
          "/aml",
        ];
        window.fcWidget.on("widget:closed", function (resp) {
          if (
            window.innerWidth < 768 &&
            !pathnames.find((ele) => ele.includes(location.pathname))
          ) {
            document.querySelector(
              "#fc_frame, #fc_frame.fc-widget-normal"
            ).style.display = "none";
          }
        });
      });
    });
  }
  return (
    <>
      {" "}
      <MobileAppBottomDrawer></MobileAppBottomDrawer>
      <div>
        <Toaster
          position={"bottom-center"}
          reverseOrder={false}
          toastOptions={{
            style: {
              zIndex: 99999,
              marginTop: !isMobile ? "80px" : "",
              fontSize: "14px",
              marginBottom: "76px",
              background: darkMode ? "#fff" : "#2b2b2b",
              color: darkMode ? "#2b2b2b" : "#fff",
            },
          }}
        />
      </div>
      <Switch>
        <Route
          exact
          path={[
            "/",
            "/createacc",
            "/forgotpassword",
            "/login",
            "/contactus",
            "/careers",
            "/aboutus",
            // "/bugbounty",
            "/feespage",
            "/tandc",
            "/privacy",
            "/aml",
          ]}
        >
          <ScrollToTop />
          <CoinContextProvider>
            <PreLayout>
              <Switch>
                <Route exact path="/" component={LandingPage} />
                <Route path="/createacc" component={CreateAccForm} />
                <Route path="/forgotpassword" component={ForgotPassword} />
                <Route path="/login" component={Signin} />
                <Route path="/contactus" component={ContactUs} />
                <Route path="/careers" component={Careers} />
                <Route path="/aboutus" component={AboutUs} />
                {/* <Route path="/bugbounty" component={BugBounty} /> */}
                <Route path="/feespage" component={FeesPage} />
                <Route path="/tandc" component={TandC} />
                <Route path="/privacy" component={PrivacyPolicy} />
                <Route path="/aml" component={AmlKyc} />
              </Switch>
            </PreLayout>
          </CoinContextProvider>
        </Route>

        <Route
          exact
          path={[
            "/trade/:coin",
            "/portfolio",
            "/allnotifications",
            "/wallet/:type",
            "/wallet/crypto/deposit",
            "/wallet/crypto/withdraw",
            // "/upi/request/:id",
            "/wallet/inr/withdraw",
            "/transactions",
            "/accsettings",
            "/onboarding",
            "/settings",
            "/invite",
            "/bank",
            "/currency",
            "/orderhistory",
            "/vault",
            "/inr/deposit/direct",
            "/inr/deposit/instant",
            // "/inr/deposit/upi",
            "/wallet/inr/deposit",
            "/cryptowallet/withdraw",
            "/cryptowallet/deposit",
            "/cryptowallet",
            "/inrwallet",
            "/inr/withdraw",
            "/inr/deposit",
          ]}
        >
          <ScrollToTop />
          <CoinContextProvider>
            <Layout>
              <Switch>
                <Route
                  path="/cryptowallet"
                  exact
                  render={({ location }) => {
                    return (
                      <Redirect
                        to={`/wallet/crypto${
                          location.search ? location.search : ""
                        }`}
                      />
                    );
                  }}
                />
                <Route
                  path="/cryptowallet/deposit"
                  exact
                  render={({ location }) => {
                    return (
                      <Redirect
                        to={`/wallet/crypto/deposit${
                          location.search ? location.search : ""
                        }`}
                      />
                    );
                  }}
                />

                <Route
                  path="/cryptowallet/withdraw"
                  exact
                  render={({ location }) => {
                    return (
                      <Redirect
                        to={`/wallet/crypto/withdraw${
                          location.search ? location.search : ""
                        }`}
                      />
                    );
                  }}
                />

                <PrivateRoute path="/inr/deposit" exact>
                  <Redirect to="/wallet/inr/deposit" />
                </PrivateRoute>

                <PrivateRoute path="/inr/withdraw" exact>
                  <Redirect to="/wallet/inr/withdraw" />
                </PrivateRoute>
                <PrivateRoute path="/inrwallet">
                  <Redirect to="/wallet/inr" />
                </PrivateRoute>

                <PrivateRoute
                  path="/trade/:coin"
                  component={Tradetab}
                  authenticationNotNeeded={true}
                />
                <PrivateRoute
                  path="/currency"
                  component={MobileCurrency}
                  authenticationNotNeeded={true}
                />
                <PrivateRoute
                  path="/orderhistory"
                  component={MobileOrderHistory}
                  authenticationNotNeeded={true}
                />
                <PrivateRoute path="/portfolio" component={Myportfolio} />
                <PrivateRoute
                  path="/allnotifications"
                  component={AllNotifications}
                />
                <PrivateRoute exact path="/wallet/:type" component={Wallet} />
                {/* <PrivateRoute
                  exact
                  path="/wallet/crypto"
                  component={CryptoWallet}
                /> */}
                <PrivateRoute
                  exact
                  path="/wallet/crypto/deposit"
                  component={CryptoDeposit}
                />
                <PrivateRoute
                  exact
                  path="/wallet/crypto/withdraw"
                  component={CryptoWithdraw}
                />
                {/* <PrivateRoute path="/wallet/inr" component={INRWallet} /> */}
                {/* <PrivateRoute
                  path="/upi/request/:id"
                  component={UPIDepositRequest}
                /> */}

                <PrivateRoute
                  path="/wallet/inr/withdraw"
                  component={INRWithdraw}
                />
                <PrivateRoute path="/transactions" component={Transactions} />
                <PrivateRoute path="/accsettings" component={AccountSettings} />
                <PrivateRoute path="/onboarding" component={Onboarding} />
                <PrivateRoute path="/settings" component={Settings} />
                <PrivateRoute path="/invite" component={Invite} />
                <PrivateRoute path="/bank" component={Bank} />
                <PrivateRoute
                  path="/vault"
                  component={Lend}
                  authenticationNotNeeded={true}
                />
                <PrivateRoute
                  path="/inr/deposit/direct"
                  component={DirectDeposit}
                  kyc={true}
                />
                <PrivateRoute
                  path="/inr/deposit/instant"
                  component={InstantDeposit}
                  kyc={true}
                />
                {/* <PrivateRoute
                  path="/inr/deposit/upi"
                  component={UPIDeposit}
                  kyc={true}
                /> */}

                <PrivateRoute
                  path="/wallet/inr/deposit"
                  component={INRDeposit}
                  kyc={true}
                />
              </Switch>
            </Layout>
          </CoinContextProvider>
        </Route>
        <Route path="*" exact={true} component={NotFoundPage} />
      </Switch>
    </>
  );
}

export default Routes;

const useStyles = makeStyles((theme) => ({
  list: {},
  fullList: {
    width: "auto",
  },
  paper: {
    overflow: "hidden",
    borderRadius: "30px 30px 0px 0px",
    background: "#fff",
    color: "#222",
    backdropFilter: "blur(15px)",
    WebkitBackdropFilter: "blur(15px)",
    zIndex: "9999999999",
  },
}));

function MobileAppBottomDrawer() {
  const isUsingMobileApp = useSelector(
    (state) => state.trading.IS_USING_MOBILE_APP
  );
  const ignoreMobileApp = useSelector(
    (state) => state.trading.IGNORE_MOBILE_APP
  );

  // const isValid = !ignoreMobileApp && !mobileApp && isMobile && !isIOS;
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch({
    //   type: SET_IGNORE_MOBILE_APP,
    //   payload: false,
    // });

    setTimeout(() => {
      const isUsingMobileApp = Boolean(
        window.localStorage.getItem("is_using_app")
      );

      if (
        !isUsingMobileApp &&
        !ignoreMobileApp &&
        isMobile &&
        !isIOS &&
        !Boolean(window?.ReactNativeWebView)
      ) {
        setOpen(true);
      }
    }, 1500);
  }, []);

  return (
    <Drawer
      className="shadow-lg"
      classes={{ paper: classes.paper }}
      anchor={"bottom"}
      open={open}
      onClose={(e) => {
        e.preventDefault();
      }}
    >
      <div className="px-4 py-2 flex justify-between items-center">
        <h3>Download the App Now!</h3>
        <div
          className="p-2"
          onClick={() => {
            setOpen(false);
            setTimeout(() => {
              dispatch({
                type: SET_IGNORE_MOBILE_APP,
                payload: true,
              });
            }, 1000);
          }}
        >
          <FaTimes className="text-lg"></FaTimes>
        </div>
      </div>
      <hr className="opacity-30" />
      <div className="p-4  pb-0 flex justify-between items-start">
        <div className="flex flex-col gap-y-3  ">
          <h2>Trading made Easy </h2>
          <p>
            All of your{" "}
            <span className="text-pb-primary-100 font-bold">Portfolio</span> now
            literally in your pocket!{" "}
            <span className="text-pb-primary-100 font-bold">
              Trade, earn & monitor
            </span>{" "}
            everyting with our Mobile App.
          </p>
          <img
            className={"cursor-pointer hover:opacity-70 transition-all mr-3"}
            src={require("./assets/staticAssets/googleplay.png").default}
            alt="googleplay"
            style={{ width: "140px" }}
            onClick={() => {
              window.open(
                "https://play.google.com/store/apps/details?id=com.pocketbits&referrer=utm_source%3Dws%26utm_medium%3Dweb%26utm_term%3Dmobile_app_banner",
                "_self"
              );
            }}
          />{" "}
        </div>
        <div>
          <div className="-mb-2">
            <img
              src={require("./assets/img/appDrawer.png").default}
              width={130}
            />
          </div>
        </div>
      </div>
    </Drawer>
  );
}
